exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stepFormText[data-v-5a2bb7c8] {\n  margin-bottom: 24px;\n}\n.ant-form-item-label[data-v-5a2bb7c8],\n.ant-form-item-control[data-v-5a2bb7c8] {\n  line-height: 22px;\n}\n.getCaptcha[data-v-5a2bb7c8] {\n  display: block;\n  width: 100%;\n  height: 40px;\n}\n", ""]);

// exports
